<script setup lang="ts">
defineProps<{
  isMenuOpen: boolean
  items: any[]
}>()

const emit = defineEmits(['update:isMenuOpen'])
</script>

<template>
  <div class="border-b-1 h-17 xl:h-20">
    <div class="max-w-1160px flex justify-between gap-4 px-4 lg:px-0 lg:justify-start lg:mx-auto font-poppins h-full">
      <div class="flex items-center">
        <NuxtLink to="/">
          <img src="@/assets/logo.png" alt="skupinaklik_logo">
        </NuxtLink>
      </div>
      <div class="flex items-center lg:hidden">
        <TheNavigationHamburger
          :open="isMenuOpen"
          @click="$emit('update:isMenuOpen', !isMenuOpen)"
        />
      </div>
      <!-- Desktop view -->
      <nav class="<lg:hidden">
        <div class="flex items-center headline-1 h-full">
          <div class="flex gap-2" :class="{ isMenuOpen }">
            <TheNavigationMenu :items="items" @is-menu-open="emit('update:isMenuOpen', false)" />
          </div>
        </div>
      </nav>
      <!-- Mobile view -->
      <nav class="text-white font-poppins hidden" :class="{ isMenuOpen }">
        <TheNavigationMenu :items="items" @is-menu-open="emit('update:isMenuOpen', false)" />
      </nav>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.isMenuOpen {
  @screen <lg {
    @apply left-0 top-17 absolute flex flex-col z-50 bg-primary w-full
  }
}

.router-link-active {
  @apply pointer-events-none
}
</style>
